// import React, {useState, useEffect, useRef } from 'react'
// import './footer.css'
// import logo from '../../main_assets/logo.png';
// import link from '../../main_assets/link.PNG';
// import { PopupModal } from 'react-calendly';


// const Footer = () => {
//   const [currentWord, setCurrentWord] = useState('people');
//   const words = ['people', 'products', 'companies', 'solutions'];
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [displayText, setDisplayText] = useState('people');
//   const currentWordIndex = useRef(0);
//   const isErasing = useRef(false);
//   const charIndex = useRef(0);
  
//   const shareUrl = 'https://your-website-url.com';
//   const title = 'Check out our awesome website!';

//   const openModal = () => setModalOpen(true);
//   const closeModal = () => setModalOpen(false);

//   const handleShareButtonClick = () => {
//     openModal();
//   };

//   const handleModalClose = () => {
//     closeModal();
//     document.body.classList.remove('popup-open');
//   };

//   const handleModalOpen = () => {
//     openModal();
//     document.body.classList.add('popup-open');
//   };

//   useEffect(() => {
//     const handleBodyScroll = () => {
//       if (isModalOpen) {
//         document.body.style.overflow = 'hidden';
//       } else {
//         document.body.style.overflow = 'auto';
//       }
//     };

//     handleBodyScroll(); 
//     window.addEventListener('scroll', handleBodyScroll);
//     return () => {
//       window.removeEventListener('scroll', handleBodyScroll); 
//     };
//   }, [isModalOpen]);

//   useEffect(() => {
//     const typewriterEffect = () => {
//       // Current complete word
//       const currentWord = words[currentWordIndex.current];
      
//       if (isErasing.current) {
//         // Erasing characters from right to left
//         if (charIndex.current > 0) {
//           setDisplayText(currentWord.substring(0, charIndex.current - 1));
//           charIndex.current -= 1;
//         } else {
//           // Done erasing, prepare for typing the next word
//           isErasing.current = false;
//           currentWordIndex.current = (currentWordIndex.current + 1) % words.length;
//           // Small delay before starting to type next word
//           setTimeout(typewriterEffect, 500);
//           return;
//         }
//       } else {
//         // Displaying the full word
//         const nextWord = words[currentWordIndex.current];
//         setDisplayText(nextWord);
//         charIndex.current = nextWord.length;
        
//         isErasing.current = true;
//         setTimeout(typewriterEffect, 2000); 
//         return;
//       }
      
//       // Schedule next update
//       const speed = isErasing.current ? 100 : 200; 
//       setTimeout(typewriterEffect, speed);
//     };

//     // Start the effect
//     const timeoutId = setTimeout(typewriterEffect, 1000);
    
//     return () => clearTimeout(timeoutId);
//   }, []);

//   return (
//     <>
//       <div className="ulev__footer-icotext section__padding">
//         <p style={{ marginRight: 'auto', background: 'none', border: 'none' }}>
//           We are always looking <br/> to connect with great <span className="changing-word">{displayText}</span>.
//         </p>
//         <button style={{ display: 'flex', alignItems: 'center', marginRight: 'auto', background: 'none', border: 'none' }}>
//           <p className='reach' style={{ marginRight: '10px', color: "#888" }}>Connect with us</p>
//         </button>

//         <button className='cont' onClick={openModal} style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginTop: '25px', cursor: 'pointer', background: 'none', border: 'none' }}>
//           <span style={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
//             <img src={link} alt="linked" />
//           </span>
//         </button>
//       </div>
//       <div className="ulev__footer">
//         <div className="ulev__footer-btn">
//           <div className='img'>
//             <img src={logo} alt="logo" className="ulev__footer-btn-image" />
//           </div>
//           <div className="ulev__footer-links_logo">
//             {/* <p className='location'>Cameroon:</p> */}
//             <p>Bonamoussadi,</p>
//             <p>Terminus Bar,</p>
//             <p>(+237) 612-345-678</p>
//           </div>
//           <div className="ulev__footer-links_logo">
//             {/* <p className='location'>Cameroon:</p> */}
//             <p>Mail:</p>
//             <p>info@ulevus.com</p>
//           </div>
//           <div className="ulev__footer-copyright">
//             {/* <p className='location'>USA:</p> */}
//             <p>Instagram</p>
//             <p>Facebook</p>
//             <p>Twitter</p>
//             <p>LinkedIn</p>
//           </div>
//         </div>

//         <div className='rights__parent'>
//           <div className='rights'> 
//             <p>@2025</p>
//             <p>All rights reserved</p>
//           </div>
//         </div>

//         <div className='bood'>
//           <hr className="white__divider-foot" />
//         </div>

//         <div className="ulev__footer-links">
//           <div className="ulev__footer-text">
//             <div className='text'>
//               <p>ULEVUS</p>
//             </div>
//           </div>
//         </div>
        
//       </div>
//     </>
//   );
// }

// export default Footer







import React, { useState, useEffect, useRef } from 'react';
import './footer.css';
import logo from '../../main_assets/logo.png';
import link from '../../main_assets/link.PNG';
import ulevus from '../../main_assets/ULEVUS.png';
import { PopupModal } from 'react-calendly';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const Footer = () => {
  const words = ['people', 'products', 'companies', 'solutions'];
  const [isModalOpen, setModalOpen] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const currentWordIndex = useRef(0);
  const isTyping = useRef(true);
  const charIndex = useRef(0);
  
  const [footerContent, setFooterContent] = useState({
    address: {
      lines: ['Terminus,', 'Bonamoussadi,', 'Douala,', 'Cameroon.']
    },
    contact: {
      email: 'info@ulevus.com',
      phone: '(+237) 612-345-678'
    },
    socialLinks: {
      instagram: {
        url: 'https://www.instagram.com/thisisulevus/',
        text: 'Instagram'
      },
      facebook: {
        url: 'https://web.facebook.com/thisisulevus/',
        text: 'Facebook'
      },
      twitter: {
        url: 'https://x.com/thisisulevus/',
        text: 'Twitter'
      },
     
      linkedin: {
        url: 'https://www.linkedin.com/company/ulevus/',
        text: 'LinkedIn'
      },
      youtube: {
        url: 'https://www.youtube.com/@thisisulevus/',
        text: 'Youtube'
      },
      
    }
  });
  
  const shareUrl = 'https://your-website-url.com';
  const title = 'Check out our awesome website!';

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleShareButtonClick = () => {
    openModal();
  };

  const handleModalClose = () => {
    closeModal();
    document.body.classList.remove('popup-open');
  };

  const handleModalOpen = () => {
    openModal();
    document.body.classList.add('popup-open');
  };

  // Fetch footer content from Firestore
  useEffect(() => {
    const fetchFooterContent = async () => {
      try {
        const docRef = doc(db, 'siteSettings', 'content');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists() && docSnap.data().footer) {
          setFooterContent(docSnap.data().footer);
        }
      } catch (error) {
        console.error("Error fetching footer content:", error);
      }
    };

    fetchFooterContent();
  }, []);

  useEffect(() => {
    const handleBodyScroll = () => {
      if (isModalOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    handleBodyScroll(); 
    window.addEventListener('scroll', handleBodyScroll);
    return () => {
      window.removeEventListener('scroll', handleBodyScroll); 
    };
  }, [isModalOpen]);

  useEffect(() => {
    const typewriterEffect = () => {
      const currentWord = words[currentWordIndex.current];
      
      if (isTyping.current) {
        if (charIndex.current < currentWord.length) {
          setDisplayText(currentWord.substring(0, charIndex.current + 1));
          charIndex.current += 1;
          setTimeout(typewriterEffect, 100);
        } else {
          isTyping.current = false;
          setTimeout(typewriterEffect, 1500);
        }
      } else {
        setDisplayText('');
        charIndex.current = 0;
        isTyping.current = true;

        currentWordIndex.current = (currentWordIndex.current + 1) % words.length;

        setTimeout(typewriterEffect, 500);
      }
    };

    const timeoutId = setTimeout(typewriterEffect, 1000);
    
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <div className="ulev__footer">
      <div className="ulev__footer-btn">
        {/* Left column - Address */}
        <div className="ulev__footer-links_logo">
          {footerContent.address.lines.map((line, index) => (
            <p key={`address-line-${index}`}>{line}</p>
          ))}
        </div>
        
        {/* Middle column - Contact Information */}
        <div className="ulev__footer-links_logo middle-column">
          <p>{footerContent.contact.email}</p>
          <p>{footerContent.contact.phone}</p>
        </div>
        
        {/* Right column - Social Links */}
        <div className="ulev__footer-copyright">
          {Object.entries(footerContent.socialLinks).map(([platform, data], index) => (
            <p key={`social-${platform}`}>
              <a 
                href={data.url} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {data.text}
              </a>
            </p>
          ))}
        </div>
      </div>

        <div className='rights__parent'>
          <div className='rights'> 
            <p>@2025</p>
            <p>All rights reserved</p>
          </div>
        </div>

        <div className='bood'>
          <hr className="white__divider-foot" />
        </div>

      <div className="ulev__footer-links">
        <div className="ulev__footer-text">
          <div className="text full-width">
            <img 
              src={ulevus} 
              alt="ULEVUS" 
              className="ulevus-logo-img"
              style={{width: '100%', height: 'auto', objectFit: 'contain'}}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Footer;